<script setup lang="ts">
import {useHttpStore} from "~/composables/stores/http.store";
import {useDataStore} from "~/composables/stores/data.store";
import type {languagesCommon} from "~~/schemas/main.schema.dto";


let http = useHttpStore()
let data = useDataStore()

//
// seo stuff
const route = useRoute()
const {locale,t} = useI18n()
let lang = computed(() => locale.value as unknown as languagesCommon)
const head = useLocaleHead({
  addDirAttribute: true,
  identifierAttribute: 'id',
  addSeoAttributes: true,
})
// named argument is interpreted from translation files, this means replace {title} with the value of route.meta.title translation
const title = computed(() => t('layouts.title', {title: t(route.meta.title ?? 'defaultTitle')}))

let ignore = false
watch(route, () => {
  if (route.meta.ignoreCanonicals) {
    ignore = true
  } else {
    ignore = false
  }
}, {immediate: true})
// igy kell hasznalni dynamic tobbnyelvu routenal
// definePageMeta({
//   // control initial seo tags with this!
//   ignoreCanonicals: true,
// })
// // https://github.com/nuxt-modules/i18n/pull/2580
// // guess this manually sets the tags
// // note, after first ignore it can be set dynamically (not that it is useful because google....)
// const setI18nParams = useSetI18nParams()
// setI18nParams({
//   hu: {
//     type: patterns.value[0].ClotheType.name.hu
//   },
//   en: {
//     type: patterns.value[0].ClotheType.name.en
//   }
// })

// this doesnt seem to update on navigation
// const setI18nParams = useSetI18nParams()
// setI18nParams({})
</script>

<template>
  <!--  set html seo lang tags-->
  <Html :lang="head!.htmlAttrs!.lang" :dir="head!.htmlAttrs!.dir">
  <Head>
    <Title>{{ title }}</Title>
    <template v-if="!ignore"  v-for="link in head.link" :key="link.id">
      <Link :id="link.id" :rel="link.rel" :href="link.href" :hreflang="link.hreflang"/>
    </template>
    <template v-for="meta in head.meta" :key="meta.id">
      <Meta :id="meta.id" :property="meta.property" :content="meta.content"/>
    </template>
  </Head>
  <Body>
  </Body>
  </Html>
</template>

<style scoped>

</style>